import { render, staticRenderFns } from "./EditAgency.vue?vue&type=template&id=6d40cbb8"
import script from "./EditAgency.vue?vue&type=script&lang=ts"
export * from "./EditAgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports